import React, { Component } from "react";
import { connect } from "react-redux";
import * as actions from "../../store/actions/index";
import axiosBackEnd from "../../config/axios/axios-back-end";
import _ from "lodash";

import { Collapse, message } from "antd";

import FormOne from "../../components/AppConfig/RoleAppConfigManager/FormOne";
import FormTwo from "../../components/AppConfig/RoleAppConfigManager/FormTwo";

const { Panel } = Collapse;

class AppConfigManager extends Component {
  state = {
    dataOne: null,
    applicationsMapByAppName: null,
    create: true,
    selectData: null,
  };
  formOneFormRef = React.createRef();
  formTwoFormRef = React.createRef();

  async componentDidMount() {
    await this.props.mainRolesGet();
    await this.props.rolesListGet();

    if (!this.props.api.applicationsGetData) {
      await this.props.applicationsGet();
    }
    if (
      this.props.api.applicationsGetData &&
      this.props.api.applicationsGetData.data
    ) {
      const applicationsMapByAppName = _.keyBy(
        this.props.api.applicationsGetData.data,
        "app_name",
      );
      this.setState({ applicationsMapByAppName: applicationsMapByAppName });
    }
  }

  getDataOne = async (data) => {
    this.props.apiStart();
    try {
      const headers = {
        "Content-Type": "application/json",
      };
      const response = await axiosBackEnd.get("/api/roles/app-config", {
        params: data,
        headers: headers,
      });
      if (response && response.data && response.data.data) {
        this.setState({ dataOne: response.data.data });
      }
      this.formTwoFormRef.current.resetFields();
      const fieldsValues = {};
      if (
        response &&
        response.data &&
        response.data.data &&
        response.data.data.app_config_data
      ) {
        for (const e of response.data.data.app_config_data) {
          if (e.app_id && e.app_id._id) {
            fieldsValues[e.app_id._id] = {};
            if (e.config) {
              for (const [k, a] of Object.entries(e.config)) {
                fieldsValues[e.app_id._id][k] = a;
              }
            }
          }
        }
      }
      this.formTwoFormRef.current.setFieldsValue(fieldsValues);
      this.props.apiComplete();
      // console.log("server res: ", res);
    } catch (err) {
      if (err.response) {
        const errors = err.response.data.errors;
        if (errors) {
          errors.forEach((error) => message.error(error.msg));
        }
      } else {
        message.error(err.message);
      }
      this.props.apiComplete();
      console.log("Eroor: ", err);
    }
  };

  mainRoleOnChange = async (value) => {
    this.setState({ selectData: null, dataOne: null });
  };

  roleIdOnChange = async (value) => {
    if (value) {
      this.getDataOne({ role_id: value });
    } else {
      this.setState({ dataOne: null });
    }
  };

  formOneOnFinish = async (data) => {
    if (this.state.selectData) {
      if (data.role_name) {
        if (
          await this.props.roleUpdate({
            _id: this.state.selectData._id,
            role_name: data.role_name,
          })
        ) {
          this.props.setNull("rolesGetData");
          this.formOneFormRef.current.resetFields();
          this.setState({ selectData: null, dataOne: null });
          await this.props.rolesListGet();
        }
      }
    } else {
      if (
        await this.props.roleCreate({
          role_name: data.role_name_1,
          main_role_id: data.main_role,
        })
      ) {
        this.props.setNull("rolesGetData");
        this.formOneFormRef.current.resetFields();
        await this.props.rolesListGet();
      }
    }
  };

  formTwoOnFinish = async (data) => {
    const send_data = {};
    send_data._id =
      this.state.dataOne && this.state.dataOne._id
        ? this.state.dataOne._id
        : null;
    send_data.app_config_data = data;
    this.props.apiStart();
    try {
      const headers = {
        "Content-Type": "application/json",
      };
      // const response = await axiosBackEnd.get("/api/roles/app-config", { params: data, headers: headers });
      const response = await axiosBackEnd.post(
        "/api/roles/app-config-update",
        send_data,
        { headers: headers },
      );
      if (response.data) {
        message.success(response.data.message);
      } else {
        console.log("Eroor: ", response);
      }
      this.props.apiComplete();
    } catch (err) {
      if (err.response) {
        const errors = err.response.data.errors;
        if (errors) {
          errors.forEach((error) => message.error(error.msg));
        }
      } else {
        message.error(err.message);
      }
      this.props.apiComplete();
      console.log("Eroor: ", err);
    }
  };

  roleName1OnChange = (value) => {
    if (value) {
      const result = this.props.api.rolesListGetData.data.find(
        (e) => e.role_name.toUpperCase().trim() === value.toUpperCase().trim(),
      );
      if (result) {
        this.setState({ create: false, selectData: result });
        this.getDataOne({ role_id: result._id });
        this.formOneFormRef.current.setFieldsValue({
          main_role: result.main_role_id ? result.main_role_id : undefined,
          role_name: result.role_name,
        });
      } else {
        this.setState({ create: true, selectData: null, dataOne: null });
      }
    } else {
      this.setState({ create: true, selectData: null, dataOne: null });
    }
  };

  roleDelete = async (value) => {
    if (await this.props.deleteItem({ type: "role", _id: value })) {
      this.props.setNull("rolesGetData");
      this.formOneFormRef.current.resetFields();
      this.setState({ selectData: null, dataOne: null });
      await this.props.rolesListGet();
    }
  };

  render() {
    return (
      <div>
        <div className="container_ab">
          <div className="container_style_2">
            <Collapse defaultActiveKey={["1_1"]} expandIconPosition="end">
              <Panel header="Role App Config" key="1_1" arrow="right">
                <div className="is_form_1">
                  {this.props.api.rolesListGetData &&
                  this.props.api.mainRolesGetData ? (
                    <FormOne
                      // wrappedComponentRef={this.formOneSaveFormRef}
                      // onSubmit={this.formOneSubmit}

                      mainRolesGetData={this.props.api.mainRolesGetData.data}
                      rolesListGetData={this.props.api.rolesListGetData.data}
                      mainRoleOnChange={this.mainRoleOnChange}
                      roleIdOnChange={this.roleIdOnChange}
                      formOneOnFinish={this.formOneOnFinish}
                      roleName1OnChange={this.roleName1OnChange}
                      selectData={this.state.selectData}
                      formRef={this.formOneFormRef}
                      roleDeletePermission={
                        this.props.api.permission.sm_role_delete
                      }
                      roleDelete={this.roleDelete}
                    />
                  ) : null}
                </div>
              </Panel>
            </Collapse>

            <div style={{ marginBottom: 20 }}></div>

            {this.state.dataOne ? (
              <FormTwo
                formTwoOnFinish={this.formTwoOnFinish}
                formRef={this.formTwoFormRef}
                applicationsMapByAppName={this.state.applicationsMapByAppName}
              />
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}

// const WrappedApp = Form.create({ name: "coordinated" })(RoleManager);

const mapStateToProps = (state) => {
  return {
    api: state.api,
  };
};

const mapDispatchToProps = (dispatch) => ({
  rolesListGet: () => dispatch(actions.rolesListGet()),
  mainRolesGet: () => dispatch(actions.mainRolesGet()),
  roleCreate: (data) => dispatch(actions.roleCreate(data)),
  roleUpdate: (data) => dispatch(actions.roleUpdate(data)),
  applicationsGet: () => dispatch(actions.applicationsGet()),
  deleteItem: (data) => dispatch(actions.deleteItem(data)),
  apiStart: (data) => dispatch(actions.apiStart(data)),
  apiComplete: (data) => dispatch(actions.apiComplete(data)),
  setNull: (data) => dispatch(actions.setNull(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AppConfigManager);
